import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, reduxForm, reset } from 'redux-form';
import { renderAutoCompleteMultipleSelection, renderCheckBox, renderDateField, renderTextField, renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';
import PaginatorCustom from '../../../../components/paginationCustom';
import { getClaimMasterData, getPatient, getProcessedEVVClaims, EVVFileDownload, SubmitBatchEVVClaim,getEVVClientName } from './actions/ManageClaimActions';
import { resetFiltersAndSorting, showFormatedDate, showFormatedDateandTime } from '../../../../actions/utilAction';
import SortingCustom from '../../../../components/SortingCustom';
import moment from 'moment';
import ClaimInternalNotesModal from './ClaimInternalNotes_Modal';
import AddNoteModal from './AddNoteModal';
import CliamHistoryModal from './CliamHistoryModal';
import Alert from 'react-s-alert';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};
class EVVProccessedClaim extends Component {

  constructor(props) {
    super(props);

    this.state = {
      claimId: null,
      patientName: null,
      payerName: null,
      claimIdArray: [],
      PatientId: null,
      PatientIds: null,
      ServiceCodes: null,
      RenderingProviderIds: null,            
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      selectedEVVClaimIds: [],      
      MasterEVVRejectionReasonCodes: null,
      openInternalNotesModal: false,
      isAddNoteModalOpen: false,
      openClaimHistoryModal: false,
      masterTags: [],
      isExcludeTag: [],
      IsSearchForSingleClaim: false,      
      locationId: 0,
      ClickedOn : '',
      ServiceLocationTypeIds: null,
      ClaimPaymentStatusIds: null,
      EvvStatus: [{ id: 'approved', value: 'Approved' }, { id: 'rejected', value: 'Rejected' }],
      EvvStatusCode: null,
    };

    this.filter = {
      sort_Column: 'claimId',
      sort_Order: 'desc',
    };

    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchProcessedEVVClaim = this.handleSearchProcessedEVVClaim.bind(this);
    this.handleClaimIDCheck = this.handleClaimIDCheck.bind(this);
    this.checkAllClaimId = this.checkAllClaimId.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.CheckClaim = this.CheckClaim.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);    
  }

  loadData(page_number) {
    let IsNoPaymentStatus = false;
    if (this.state.ClaimPaymentStatusIds && this.state.ClaimPaymentStatusIds.length === 1) {
      IsNoPaymentStatus = this.props.masterClaimPaymentStatus.filter((obj) => obj.id === this.state.ClaimPaymentStatusIds[0] && obj.globalCodeValue.toLowerCase() === 'no payment status').length > 0 ? true : false;
    }
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'claimevvid',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {
        claimId: this.state.ClaimId && this.state.IsSearchForSingleClaim ? (Number.isInteger(this.state.ClaimId) ? 'CL' + this.state.ClaimId.toString().trim() : this.state.ClaimId.trim()) : null,
        patientIds: this.state.PatientIds ? this.state.PatientIds : '',        
        payerName: this.state.payerName ? this.state.payerName : '',
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date().setDate(new Date().getDate() - 7),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        claimStatusId: 6,
        masterEVVRejectionReasonCodes: this.state.MasterEVVRejectionReasonCodes ? this.state.MasterEVVRejectionReasonCodes : '',
        serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
        tagIds: this.state.masterTags,
        isExcludeTag: this.state.isExcludeTag,
        renderingProviderIds: this.state.RenderingProviderIds ? this.state.RenderingProviderIds : '',
        locationId: this.state.locationId ? this.state.locationId : 0,
        serviceLocationTypeIds: this.state.ServiceLocationTypeIds ? this.state.ServiceLocationTypeIds : '',
        //claimPaymentStatusIds: this.state.ClaimPaymentStatusIds ? this.state.ClaimPaymentStatusIds : '',
        claimPaymentStatusIds: IsNoPaymentStatus ? '0' : this.state.ClaimPaymentStatusIds ? this.state.ClaimPaymentStatusIds : null,
        evvStatusCode : this.state.EvvStatusCode ? this.state.EvvStatusCode : '',
      },
      pageNumber: page_number ? page_number : 1,
      pageSize: 50,
    };
    // console.log('searchObj........',searchObj)
    this.props.getProcessedEVVClaims(searchObj);

  }


  componentWillMount() {

    let searchObj = {
      // locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj);
    this.loadData();

    let masterData = { 'masterdata': 'MASTEREVVINSURANCECOMPANY,MASTEREVVREJECTIONREASONS,EVVSERVICECODE,MASTERTAGSFORALL,MASTERRENDERINGPROVIDERINCLUDINGINACTIVE,MASTERLOCATION,MASTERPATIENTLOCATION,CLAIMPAYMENTSTATUS' };
    this.props.getClaimMasterData(masterData);
    this.props.getEVVClientName()
  }

  componentWillReceiveProps(nextProps) {  
    if (nextProps.edi837ForSecondary && nextProps.edi837ForSecondary !== this.props.edi837ForSecondary) {
      this.setState({ selectedEVVClaimIds: [] });
      this.ResetAllClaims();
      this.loadData();
    }
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, claimId.........', obj)
    this.setState({ openInternalNotesModal: true, ClaimId: obj.claimId });    
  };
    
  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }
  handleNewRequestMultiSelect(input, selectedValues) {    
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues,
      });
    } else if (input.name === 'MasterEVVRejectionReasonCodes') {      
      this.setState({
        MasterEVVRejectionReasonCodes: selectedValues,
      });
    }
    else if (input.name === 'EvvStatus') {      
      this.setState({
        EvvStatusCode: selectedValues,
      });
    }   
    else if(input.name === 'MasterServiceCode')
    {      
      this.setState({
        ServiceCodes: selectedValues,
      });
    }
    else if(input.name === 'RenderingProviderIds')
    {
      this.setState({
        RenderingProviderIds: selectedValues,
      });
    }
    else if(input.name === 'ServiceLocationTypeIds')
    {      
      this.setState({
        ServiceLocationTypeIds: selectedValues,
      });
    }
    else if(input.name === 'ClaimPaymentStatus')
    {      
      this.setState({
        ClaimPaymentStatusIds: selectedValues,
      });
    }
  }

  handleChangePatientInsurance = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ payerName: selected.label })
    //this.setState({ [input.name]: selected.label });
  }

  handleSearchProcessedEVVClaim(event) {
    // event.preventDefault();
    // console.log('event............',event);
    this.setState({
      ClaimId: event.claimId ? event.claimId : null,
      IsSearchForSingleClaim: event.claimId ? true : false,
      PatientIds: this.state.PatientIds ? this.state.PatientIds : '',      
      PayerName: event.InsuranceCompany ? event.InsuranceCompany : '',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),
      MasterEVVRejectionReasonCodes: this.state.MasterEVVRejectionReasonCodes ? this.state.MasterEVVRejectionReasonCodes : '',      
      serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
      evvStatusCode : this.state.EvvStatusCode ? this.state.EvvStatusCode : '',      
      // PayerName: event.InsuranceCompany ? event.InsuranceCompany : '',
    }, () => {
      this.loadData();
    });
    // console.log('event............',event);
  }

  CheckClaim(e, index, claimId) {
    let selectedEVVClaimIds = this.state.selectedEVVClaimIds;    
    let isClaimChecked = e.target.checked;
    if (isClaimChecked) {
      //selectedEVVClaimIds.push(claimId);   
      if(selectedEVVClaimIds.indexOf(claimId) === -1)
      {
        selectedEVVClaimIds.push(claimId);   
      }      
    } else {
      index = selectedEVVClaimIds.findIndex((value) => value === claimId);
      if (index >= 0) {
        selectedEVVClaimIds.splice(index, 1);
      }
    }

    this.setState({ selectedEVVClaimIds });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }
  handleClose = () => {
    this.setState({  openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEVVClaimIds:[] }, () => this.handleReset());
  };

  closeDialog = () => {
    this.setState({  openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEVVClaimIds:[] },()=>this.props.dispatch(reset('ProcessedEVVClaimForm', 'chk', null)));
  };

  ResetAllClaims() {
    this.props.dispatch(change('ProcessedEVVClaimForm', 'chk', false));    
    this.props.processedEVVClaim.data.ProcessedEVVClaims.map((Obj, index) => {
      let claimIdCheck = `Check${Obj.claimId}`;      
      this.props.dispatch(change('ProcessedEVVClaimForm', claimIdCheck, false));
    });
  }


  handleCloseWithoutReset = () => {    
    this.ResetAllClaims();
    this.setState({  openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEVVClaimIds:[] });
  }

  handleClaimIDCheck = (input) => {
    // console.log('input.target.name......', input.target.value);
    // console.log('input.target.checked......', input.target.checked);
    let inputName = input.target.value;
    let inputvalue = inputName.replace('Check', '');
    // console.log('inputvalue......', inputvalue);
    let value = parseInt(inputvalue, 10);
    if (input.target.checked) {
      let claimArray = this.state.claimIdArray,
        id = Number.isInteger(value) ? value : null;
      claimArray.push(id);
      this.setState({
        claimIdArray: claimArray || null,
      });
      // console.log('this.state.claimIdArray................', this.state.claimIdArray);
    } else {
      let claimArray = this.state.claimIdArray,
        index = claimArray.indexOf(value);
      if (index >= 0) {
        claimArray = claimArray.splice(index, 1);
        this.setState({
          claimIdArray: claimArray || null,
        });
        // console.log('this.state.claimIdArray................', this.state.claimIdArray);

      }
    }
  }
  handleReset = () => {
    this.props.dispatch(reset('ProcessedEVVClaimForm'));
    resetFiltersAndSorting(this.filter, 'claimId', true);
    this.setState({
      openInternalNotesModal: false,
      ClaimId: null,
      PatientIds: null,      
      MasterEVVRejectionReasonCodes: null,
      PayerName: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      claimIdArray: [],
      masterTags: [],
      isExcludeTag: [],            
      RenderingProviderIds: null,
      locationId: 0,
      ServiceLocationTypeIds: null,
      ClaimPaymentStatusIds: null,
      EvvStatusCode : null,
    }, () => {
      this.loadData();
    });
  };
  handleExpandRow = (claimId) => {
    this.setState({ ClaimId: claimId });
    let display = this.refs['expandedClass' + claimId].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + claimId].style.display = 'table-row';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claimId].style.display = 'none';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-ellipsis-h';
    }
  }
  checkAllClaimId(input) {
    // console.log('input.target.checked.........', e.target.checked);
    let selectedEVVClaimIds = [];    
    this.props.processedEVVClaim.data.ProcessedEVVClaims.map((Obj, index) => {
      //console.log('Obj........', Obj);
      let claimCheck = 'Check' + Obj.claimId;
      if (Obj && input.target.checked) {
        //selectedEVVClaimIds.push(Obj.claimId);        
        if(selectedEVVClaimIds.indexOf(Obj.claimId) === -1)
        {
          selectedEVVClaimIds.push(Obj.claimId);      
        }
         //console.log('claimCheck........', claimCheck);
        return this.props.dispatch(change('ProcessedEVVClaimForm', claimCheck, true));
      } else {
         //console.log('claimCheck1........', claimCheck);
        return this.props.dispatch(change('ProcessedEVVClaimForm', claimCheck, false));
      }
    });
    this.setState({ selectedEVVClaimIds });
  }

  handleOpenHistory = (event, claimId) => {
    this.setState({
      openClaimHistoryModal: true,
      ClaimId: claimId
    });
  }

  handleCloseClaimHistoryModal = () => {
    this.setState({
      openClaimHistoryModal: false
    });
  }

  
  handleAlertBatchEVVGenerationClick = (event) => {
    //console.log('this.state.selectedEVVClaimIds.toString()...........',this.state.selectedEVVClaimIds.toString())
    this.props.SubmitBatchEVVClaim(this.state.selectedEVVClaimIds.toString(), 3);
    Alert.closeAll();
  }

  handleBatchEVVGeneration = (event) => {
    Alert.warning('Are you sure you want to submit selected claims for EVV generation?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertBatchEVVGenerationClick,
        //id: obj.id,
      },
    });
  }

  handleAddBulkNoteClick = () => {
    this.setState({
      isAddNoteModalOpen: true
    })
  }

  handleNewRequest = (input, selectedValues) => {
    if (input.name === 'tags') {      
        input.onChange(selectedValues);
        this.setState({
          masterTags: selectedValues,
        }, () => this.state.masterTags.length === 0 ? this.props.dispatch(reset('ProcessedEVVClaimForm',"ExcludeTag", false)): '');
    }
    else if (input.name === 'locationId') {              
      this.setState({  locationId : selectedValues.value }, () => {input.onChange(selectedValues.value);});
    }    
  }

  
  isExcludeTagHandler = (e) => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    });
  }


  handleDownloadClick = (docId, fileName) => {
    this.props.EVVFileDownload(docId, fileName);
  }

  renderInnerData(claim837ClaimId) {
    
    // console.log('this.props.processedEVVClaim.......', this.props.processedEVVClaim);
    let processedClaimInnerData = this.props.processedEVVClaim.data.ProcessedEVVClaimServiceLines || [],
      filteredProcessedClaimInnerData = processedClaimInnerData.filter((obj) => obj.claim837ClaimId === claim837ClaimId);
    return filteredProcessedClaimInnerData.map((innerData, index) => {
      return (
        <tbody key={index}>
          <tr>
            <td width="10%"></td>            
            <td width="15%">{innerData.serviceCode}</td>
            {/* <td width="10%">{innerData.serviceFacilityCode}</td> */}
            <td width="20%">{innerData.evvReasonCodes}</td>
            {/* <td width="35%">{innerData.evvRejectedReason}</td> */}
            <td width="10%"></td>
          </tr>
        </tbody>
      );
    });
  };

  renderData() {
    const tableClass1 = classNames({
      'table': true,
      'middletable ': true,
      'customtable': true,
      'colorChange': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    return this.props.processedEVVClaim.data.ProcessedEVVClaims.map((Obj, index) => {
      // console.log('Obj.......',Obj );
      return (
        <tr key={index}>
          <td colSpan="8">
            <table className={tableClass1}>
              <tbody>
                <tr>
                  <td width="10%"> <div className="table_custom-check">
                    <Field
                      name={'Check' + Obj.claimId}                                            
                      onChange={(e) => this.CheckClaim(e, index, Obj.claimId)}
                      component={renderCheckBox}
                      style={stylescss.checkbox}
                    />
                    <button onClick={(e) => this.handleExpandRow(Obj.claimId)} type="button" className="morebtn">
                      <i ref={'expClass' + Obj.claimId} className="classExpand fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </div></td>
                  <td width="15%">{'CL' + Obj.claimId}</td>
                  <td width="10%">{showFormatedDate(Obj.dos)}</td>
                  <td width="15%">{Obj.patientName}</td>
                  <td width="15%">{Obj.payerName}</td>
                  <td width="15%">{showFormatedDateandTime(Obj.submittedDate)}</td>
                  <td width="10%">{Obj.evvStatus}</td>                  
                  <td width="10%">
                    
                    <button onClick={(e) => this.handleOpenInternalNotes(e, Obj)} type="button" title="Claim Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
                    <button onClick={(e) => this.handleOpenHistory(e, Obj.claimId)} type="button" title="Claim History" className="tbactionbtn bluefont"><i className="fa fa-history" aria-hidden="true"></i></button>
                    {/* {Obj.filename ?
                    <button onClick={(e) => this.handleDownloadClick(Obj.claim837ClaimId, Obj.filename)} type="button" title="Download EVV" className="tbactionbtn bluefont"><i className="fa fa-download" aria-hidden="true"></i></button>
                    :null} */}
                  </td>
                </tr>
                <tr className="nohover" ref={'expandedClass' + Obj.claimId} style={{ 'display': 'table-row' }}>
                  <td colSpan="8">
                    <table className={tableClass2}>
                      <thead>
                        <tr>
                          <th width="10%"></th>                       
                          <th width="15%">Service Code</th>
                          {/* <th width="10%">Loc. Code</th>   */}
                          <th width="20%">EVV Reason Code</th>
                          {/* <th width="35%">EVV Rejected Reason</th>                           */}
                          <th width="10%"></th>
                        </tr>
                      </thead>
                      {this.renderInnerData(Obj.claim837ClaimId)}
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });
    // const tableClass1 = classNames({
    //   'table': true,
    //   'maintable': true,
    //   'customtable': true,
    // });
    return (
      <div>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchProcessedEVVClaim)}>
              <div className="row mtm-20">
                <div className="col-sm-4">
                  <Field
                    autoFocus={true}
                    name="claimId"
                    floatingLabelText="Claim ID"
                    onChange={this.handleSearchChange}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="PatientIds"
                    label="Client Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.getAllEVVClientName}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="MasterServiceCode"
                    label="Service Code"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterServiceCode}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection = {true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="InsuranceCompany"
                    label="Insurance Company"
                    handleNewRequest={this.handleChangePatientInsurance}
                    options={this.props.masterInsurances}
                    component={renderAutoCompleteSingleSelect} />
                  {/* <Field name="InsuranceCompany"
                    floatingLabelText="Insurance Company"
                    maxLength="50"
                    onChange={this.handleSearchChange}
                    component={renderTextField} /> */}
                </div>
              </div>
              <div className="row">
              <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="tags"
                    label="Tags"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterTagsForAll}
                    component={renderAutoCompleteMultipleSelection} />
                </div>                      
                {/* <div className="col-sm-4 mt-35">
                  <Field
                    name="EvvStatusCode"
                    label="Evv Status"                    
                    options={this.state.EvvStatus}                    
                    handleNewRequest={this.handleChangePatientInsurance}                    
                    component={renderAutoCompleteSingleSelect} />
                </div>   */}
                {/* <div className="col-sm-4 mt-35">
                  <Field
                    name="MasterEVVRejectionReasonCodes"
                    label="Rejection Reasons"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.MasterEVVRejectionReasonCodes}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>   */}
                {this.state.masterTags.length > 0 ?
                <div className="col-sm-4 insfield mt-35">
                 <Field
                    name="ExcludeTag"
                    label="Exclude Tag"
                    component={renderCheckBox}
                    onChange={(e) => this.isExcludeTagHandler(e)}
                    style={stylescss.checkbox}
                  />
                </div>              
                :null}
                <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="RenderingProviderIds"
                      label="Rendering Provider"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterRenderingProviderIncludingInactive}
                      component={renderAutoCompleteMultipleSelection} />
                </div> 
              </div>   
              {/* <div className="row"> 
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="locationId"
                    label="Location (Office Location of Session)"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterLocation}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ServiceLocationTypeIds"
                    label="Service Location Type"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterPatientLocation}
                    component={renderAutoCompleteMultipleSelection} />
                </div> */}
                {/* <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ClaimPaymentStatus"
                    label="Payment Status"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterClaimPaymentStatus}
                    component={renderAutoCompleteMultipleSelection}
                  />
                </div>            */}
              {/* </div> */}
              <div className="row">         
                <div className="col-10 col-sm-10 col-md-10 reset-btn claims_btn">                                    
                  {/* <RaisedButton className={this.state.selectedEVVClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedEVVClaimIds.length > 0 ? false : true} onTouchTap={(e) => this.handleAddBulkNoteClick(e)} >Add Bulk Note</RaisedButton>                  
                  <RaisedButton className={this.state.selectedEVVClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedEVVClaimIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchEVVGeneration(e)} >Batch EVV Resubmission</RaisedButton> */}
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt reset-btn claims_filter">
                  <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
            </form>
            
            {this.state.openInternalNotesModal ? <ClaimInternalNotesModal claimId={this.state.ClaimId} closeDialog={this.handleCloseWithoutReset} /> : null}

            {this.state.isAddNoteModalOpen ? <AddNoteModal ClaimId={this.state.ClaimId} PatientId={this.state.PatientId} OrganizationId={this.state.organizationID} closeDialog={this.handleCloseWithoutReset} claimIds={this.state.selectedEVVClaimIds}/> : null}

            {this.state.openClaimHistoryModal ? <CliamHistoryModal claimHistoryId={this.state.ClaimId}  PatientId={this.state.PatientId}  closeDialog={() => this.handleCloseClaimHistoryModal()}/> : null}

            
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-20">
                  {this.props.processedEVVClaim.data && this.props.processedEVVClaim.data.ProcessedEVVClaims && this.props.processedEVVClaim.data.ProcessedEVVClaims.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="10%"><div className="table_custom-check">
                            <Field
                              name= 'chk'
                              // onChange={this.handleClaimIDCheck}
                              component={renderCheckBox}
                              onChange={(input) => this.checkAllClaimId(input)}
                              style={stylescss.checkbox}
                            />
                          </div></th>
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='claimId' displayName='Claim ID' /></th>
                          <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' /></th>                          
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientName' displayName='Client' /></th>
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='payerName' displayName='Payer' /></th>
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='submittedDate' displayName='Submitted Date' /></th>
                          <th width="10%">EVV Status</th>
                          <th width="10%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="10%"><span>&nbsp;</span></th>
                          <th width="15%"><span>Claim ID</span></th>
                          <th width="10%"><span>DOS</span></th>
                          <th width="15%"><span>Client</span></th>
                          <th width="15%"><span>Payer</span></th>
                          <th width="15%"><span>Submitted Date</span></th>
                          <th width="10">Evv Status</th>
                          <th width="10%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="8">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }                 
                  {this.props.processedEVVClaim.data && this.props.processedEVVClaim.meta && this.props.processedEVVClaim.meta['totalPages'] && this.props.processedEVVClaim.meta['totalPages'] > 1 ?
                  <PaginatorCustom data={this.props.processedEVVClaim.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                  : null}
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    );
  }
};
EVVProccessedClaim = reduxForm({
  form: 'ProcessedEVVClaimForm',
})(EVVProccessedClaim);

function mapStateToProps(state) {
//  console.log('state.billing.master_data............',state.billing)
  let patients = [];
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  let masterInsurances = [], MasterEVVRejectionReasonCodes = [], masterServiceCode = [];
  let masterTagsForAll = [], masterRenderingProviderIncludingInactive = [];
  let masterLocation = [],  masterPatientLocation = [];
  if (state.billing.claimMasterData) {
    masterInsurances = state.billing.claimMasterData.evvInsuranceCompanies || [];    
    MasterEVVRejectionReasonCodes = state.billing.claimMasterData.masterEVVRejectionReasonCodes || [];
    masterServiceCode = state.billing.claimMasterData.evvServiceCode || [];
    masterTagsForAll = state.billing.claimMasterData.masterTagsforAll || [];
    masterRenderingProviderIncludingInactive = state.billing.claimMasterData.masterRenderingProviderIncludingInactive || [];
    masterLocation = state.billing.claimMasterData.masterLocation || [];
    masterPatientLocation = state.billing.claimMasterData.masterPatientLocation || [];
  }
  return {
    masterInsurances: masterInsurances,
    masterTagsForAll: masterTagsForAll,        
    masterServiceCode: masterServiceCode,
    masterRenderingProviderIncludingInactive: masterRenderingProviderIncludingInactive,
    processedEVVClaim: state.billing.processedEVVClaim,
    loginUserInfo: state.login.loginUserInfo,
    patientlist: patients,    
    MasterEVVRejectionReasonCodes: MasterEVVRejectionReasonCodes,
    edi837ForSecondary: state.billing.edi837ForSecondary,
    masterLocation: masterLocation,
    masterPatientLocation: masterPatientLocation,
    masterClaimPaymentStatus: (state.billing.claimMasterData && state.billing.claimMasterData.claimPaymentStatus) || [],
    getAllEVVClientName: state.billing.allEVVClientName&&state.billing.allEVVClientName.data
  };
}

export default connect(mapStateToProps, { getEVVClientName,getClaimMasterData, getProcessedEVVClaims, getPatient,  EVVFileDownload, SubmitBatchEVVClaim })(EVVProccessedClaim);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/EVVProccessedClaim.js